import { render, staticRenderFns } from "./FC3Chart.vue?vue&type=template&id=02f52865&"
import script from "./FC3Chart.vue?vue&type=script&lang=ts&"
export * from "./FC3Chart.vue?vue&type=script&lang=ts&"
import style0 from "./FC3Chart.vue?vue&type=style&index=0&id=02f52865&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports